var _rect, _path, _path2, _path3, _g, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg104(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "1233\uD68C \uB85C\uB610 \uD640\uC9DD\uBE44\uC728") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    rx: 28,
    fill: "#f4f0ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 90v245M230 335h340",
    stroke: "#172033",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m250 150 150-60 150 60",
    fill: "none",
    stroke: "#172033",
    strokeWidth: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M190 155h120l-25 95h-70zM490 155h120l-25 95h-70z",
    fill: "#fff",
    stroke: "#0f766e",
    strokeWidth: 7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "sans-serif",
    fontSize: 27,
    fontWeight: 900,
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 185,
    r: 27,
    fill: "#ffd666"
  }), /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 194
  }, "3"), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 185,
    r: 27,
    fill: "#ffd666"
  }), /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 194
  }, "17"), /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 185,
    r: 27,
    fill: "#b9e6dc"
  }), /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 194
  }, "8"), /*#__PURE__*/React.createElement("circle", {
    cx: 580,
    cy: 185,
    r: 27,
    fill: "#b9e6dc"
  }), /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 194
  }, "24"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 295,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 30,
    fontWeight: 900,
    fill: "#7c4a03"
  }, "\uD640\uC218")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 295,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 30,
    fontWeight: 900,
    fill: "#0f766e"
  }, "\uC9DD\uC218")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 405,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 32,
    fontWeight: 900,
    fill: "#172033"
  }, "\uBE44\uC728\uC740 \uBE44\uAD50 \uAE30\uC900, \uB2F9\uCCA8 \uACF5\uC2DD\uC740 \uC544\uB2D9\uB2C8\uB2E4")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg104);
export default __webpack_public_path__ + "static/media/104-홀짝비율.da764a123ed38673dee547872304fbfa.svg";
export { ForwardRef as ReactComponent };